import React, { memo } from 'react'
import classNames from 'classnames'
import type { ILandingFootnoteProps } from './types'
import './styles.scss'

const LandingFootnote: React.FC<ILandingFootnoteProps> = props => {
  const { message, className } = props

  return (
    <div className={classNames(className, 'page-wrapper')}>
      <div className="landingFootnote">{message}</div>
    </div>
  )
}

export default memo(LandingFootnote)
